import React from 'react';

const BoroughFilter = ({borough_filter, setBoroughFilter}) => {
  const borough_values = ['brooklyn', 'bronx', 'manhattan', 'queens', 'staten island'];
  const borough_display =  ['Brooklyn', 'Bronx', 'Manhattan', 'Queens', 'Staten Isl.'];

  const handleBoroughClick = (index) => {
    let borough = borough_values[index];
    if (borough === borough_filter) {
      setBoroughFilter(false)
    } else {
      setBoroughFilter(borough)
    }
  }

  return (
    <div>
      <div className="h6 mt2 px2 uppercase flex space-between">
        <div>Filter by Borough</div>
        {borough_filter ? (
          <div className="pointer blue hover-underline" onClick={handleBoroughClick.bind(this, false)}>Clear Filter</div>
        ) : null}
      </div>
      <div className="flex h5 py1 center">
        {borough_display.map((borough, i) =>
          <div
            key={borough}
            className={"BoroughFilterItem hover px1 bg-light-gray py1 pointer grow-1 " + (borough_values[i] === borough_filter ? 'active' : '')}
            onClick={handleBoroughClick.bind(this,i)}
          >
            {borough}
          </div>
        )}
      </div>
    </div>
  )
}

export default BoroughFilter;


/** WEBPACK FOOTER **
 ** ./src/components/BoroughFilter.js
 **/